// extracted by mini-css-extract-plugin
export default {"mobileVideoItem":"Dwovr54DG6KPsdIHv1Pj"};